import { toast } from '../store/toastStore';

/**
 * D-110 — a customer in debt never blocks work: the server answers a start
 * (timer / manual log / accepted suggestion) with `debt_warning` and the UI
 * shows its sentence: "⚠️ ללקוח X חוב פתוח (₪..., באיחור N ימים)".
 */
export function debtWarningOf(res: unknown): string | null {
  const w = (res as { data?: { debt_warning?: { message?: unknown } | null } } | null | undefined)?.data?.debt_warning;
  return w && typeof w.message === 'string' && w.message.trim() ? w.message : null;
}

/** Show the warning (if any) as a long-lived, non-blocking toast. */
export function toastDebtWarning(res: unknown): void {
  const msg = debtWarningOf(res);
  if (msg) toast('warning', msg);
}
